import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { FC, useCallback, useRef } from 'react';
import { stopDefaultEvents } from '../../utils/DataAccessUtils';

const OWButton: FC<ButtonProps> = ({
	loading,
	disabled,
	onClick,
	children,
	htmlType,
	form: formId,
	...rest
}) => {
	const isHandling = useRef(false);

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			// Block duplicate clicks and clicks while an action is in flight. For a
			// native submit button (htmlType="submit") suppressing the event here also
			// cancels the browser's default form submission, which is what guards
			// against the duplicate network submit (OPE-4836). The first click is
			// allowed through untouched so native submission — including the Enter-key
			// implicit submit — still fires exactly once.
			if (isHandling.current || loading || disabled) {
				stopDefaultEvents(e);
				return;
			}
			isHandling.current = true;

			if (onClick) {
				onClick(e);
			}

			// Reset after the current event loop tick. If the action triggered loading
			// state, disabled={loading} will block clicks until it completes. If not
			// (e.g. form validation failed), this allows the user to retry.
			setTimeout(() => {
				isHandling.current = false;
			}, 0);
		},
		[loading, disabled, onClick]
	);

	return (
		<Button
			loading={loading as boolean}
			disabled={!!(loading || disabled)}
			onClick={handleClick}
			htmlType={htmlType}
			form={formId}
			{...rest}
		>
			{children}
		</Button>
	);
};

export { OWButton };
export default OWButton;
